<template>
  <div class="navbar">
    <div class="container">
      <div class="logo" @click="goTo('/home')">
        <img src="@/assets/logo.png" alt="logo" class="logo-img" />
        <span class="logo-text">鱿鱼云码</span>
        <span class="logo-sub">智能验证码识别平台</span>
      </div>
      <ul class="nav">
        <li><a @click="goTo('/home')">首页</a></li>
        <li><a @click="goTo('/recognition')">产品及测试</a></li>
        <li><a @click="goTo('/home')">教程文档</a></li>
        <li><a @click="goTo('/home')">专属定制</a></li>
        <li><a @click="goTo('/home')">关于我们</a></li>
      </ul>
      <div class="login-box">
        <!-- 未登录 -->
        <template v-if="!isLoggedIn">
          <van-button plain class="nav-btn" @click="goTo('/login')">登录</van-button>
          <van-button type="primary" @click="goTo('/register')">注册</van-button>
        </template>
        <!-- 已登录 -->
        <template v-else>
          <van-button plain class="nav-btn" icon="user-o" @click="goTo('/user')">用户中心</van-button>
          <van-button plain class="nav-btn" @click="handleLogout">退出</van-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'Navbar',
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem('token')
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path).catch(() => {})
    },
    handleLogout() {
      localStorage.removeItem('token')
      Toast('已退出登录')
      this.goTo('/login')
    }
  }
}
</script>
